"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shades = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _internal = require("../../hooks/internal");
var _models = require("../../models");
var _internal2 = require("../../utils/internal");
var _ShadeWithName = require("./components/ShadeWithName");
var _ShadesResponsive = require("./components/ShadesResponsive");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Shades = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    code,
    shades,
    mode
  } = (0, _internal.useProduct)();
  const filteredShades = (0, _react.useMemo)(() => shades?.filter(_internal2.filterDiscontinuedShade) ?? [], [shades]);
  if (mode === _models.ProductBoxMode.Product) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShadeWithName.ShadeWithName, {});
  }
  if (filteredShades.length < 2) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ShadesRoot, {
    "data-testid": getTestId(`${_constants.SHADES}-${code}`),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShadesResponsive.InnerShades, {
      maxVisibleShadesCount: _constants2.MAX_VISIBLE_SHADES_COUNT,
      shades: filteredShades
    })
  });
};
exports.Shades = Shades;
